import Tbodycontract from 'components/table/components/tbodycontract';
import Thead from 'components/table/components/thead';
import { useLocation } from 'react-router-dom';
import Pagination from '../pagination/pagination';
import Tbodycompanycoeff from './components/Tbodycompanycoeff';
import Tbodyhours from './components/tbodyhours';
import TbodyQualification from './components/tbodyQualification';
import TbodypayslipAdmin from './components/tbodypayslipAdmin';
import ScrollableTableWrapper from './components/ScrollableTableWrapper';

const Table = ({
  champsHeader,
  champsBody,
  setChampsBody,
  errors,
  readOnly,
  type,
  currentPage,
  countPerPage,
  countTotal,
  totalPages,
  setCurrentPage,
}) => {
  const route = useLocation();
  const { pathname } = route;

  return (
    <div className="flex flex-col h-full">
      <ScrollableTableWrapper>
        <table className="table-auto w-full text-gray-500 space-y-6 ft-sm">
          <thead className="sticky top-0 z-10">
            <Thead champsHeader={champsHeader} pathname={pathname} />
          </thead>
          <tbody>
            {pathname.includes('contract') ? (
              <Tbodycontract champsBody={champsBody} />
            ) : null}
            {pathname.includes('timeSheet') ? (
              <Tbodyhours champsBody={champsBody} />
            ) : null}
            {type === 'coeff' ? (
              <Tbodycompanycoeff
                rows={champsBody}
                setRows={setChampsBody}
                errors={errors ?? []}
                readOnly={readOnly ?? false}
              />
            ) : null}
            {pathname.includes('qualification') ? (
              <TbodyQualification champsBody={champsBody} />
            ) : null}
            {pathname.includes('/payroll') ? (
              <TbodypayslipAdmin champsBody={champsBody} />
            ) : null}
          </tbody>
        </table>
      </ScrollableTableWrapper>
      {currentPage && totalPages >= 1 && setCurrentPage ? (
        <div className="flex-shrink-0 border-t border-gray-100 bg-white px-8 py-4">
          <Pagination
            currentPage={currentPage}
            countPerPage={countPerPage}
            countTotal={countTotal}
            totalPages={totalPages}
            setCurrentPage={setCurrentPage}
          />
        </div>
      ) : null}
    </div>
  );
};

export default Table;